// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"ebd4ff7d","247":"3291de75","262":"9dacce69","453":"73d7935b","465":"1f078099","662":"0bc0dd43","723":"573ac452","724":"568a8064"}[chunkId] + ".chunk.js";
};